export default __webpack_public_path__ + "static/media/TOI.95878ff1.svg";